<template>
  <table>
    <thead>
      <tr>
        <th></th>

        <th>
          <span class="t-label t-label--small t-label--dark">
            {{ $t("Altura (mm)") }}
          </span>
        </th>
        <th>
          <span class="t-label t-label--small t-label--dark">
            {{ $t("Espessura (mm)") }}
          </span>
        </th>

        <th>
          <span class="t-label t-label--small t-label--dark">
            {{ $t("Comp Alinhamento (m)") }}
          </span>
        </th>

        <th>
          <span class="t-label t-label--small t-label--dark">
            {{ $t("Peso Alinhamento (kg)") }}
          </span>
        </th>
        <th>
          <span class="t-label t-label--small t-label--dark">
            {{ $t("Peso estimado (kg/m2)") }}
          </span>
        </th>
      </tr>
    </thead>

    <tbody>
      <template
        v-if="
          Object.keys(solutionsByTypeSortedByWeightWithJustOneOfSameSteel)
            .length
        "
      >
        <template
          v-for="(
            solutions, type
          ) in solutionsByTypeSortedByWeightWithJustOneOfSameSteel"
        >
          <tr class="type_title_row" :key="type">
            <td class="type_title_cell" colspan="8">
              <p class="type_title t-label t-label--small t-label--dark">
                {{ $t("output.type", type) }}

                <Tooltip class="m-pad-0">
                  <img
                    class="type_img"
                    :src="
                      require(`@/assets/img/results_illustrations/type--${type}-spans--${
                        totalMainSpans > 1 ? 'multiple' : 'single'
                      }-lang--${selectedLang}.jpg`)
                    "
                  />
                </Tooltip>
              </p>
            </td>
          </tr>

          <template v-for="(solution, i) in solutions">
            <tr class="spacer_row" :key="i + '-' + type + 's'">
              <td class="spacer_cell"></td>
            </tr>

            <tr
              class="solution_row"
              :class="selectedSolution === solution ? 'is-selected' : ''"
              :key="i + '-' + type + 'v'"
              @click="(e) => handleSolutionRowClick(e, solution)"
            >
              <td class="solution_cell">
                <span class="solution_val">
                  <span class="t-label t-label--dark">
                    {{ solution.name }}
                  </span>
                </span>
              </td>
              <td class="solution_cell">
                <span class="solution_val">{{ solution.height }}</span>
              </td>
              <td class="solution_cell">
                <span class="solution_val">{{ solution.thickness }}</span>
              </td>
              <td class="solution_cell">
                <span class="solution_val">{{ solution.lengthAlignment }}</span>
              </td>
              <td class="solution_cell">
                <span class="solution_val">{{
                  solution.totalWeightAlignment
                }}</span>
              </td>

              <td class="solution_cell">
                <span class="solution_val">{{
                  solution.totalWeightEstimated
                }}</span>
              </td>

              <td class="solution_cell">
                <b-radio
                  @click.stop
                  :native-value="solution"
                  v-model="selectedSolution"
                ></b-radio>
              </td>
            </tr>
          </template>
        </template>
      </template>

      <template v-else>
        <tr class="spacer_row">
          <td class="spacer_cell"></td>
        </tr>

        <tr class="no_solutions_row">
          <td colspan="100" class="no_solutions_cell">
            {{
              $t(
                "Não foram encontradas opções que correspondam aos filtros seleccionados."
              )
            }}
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
import { mapState } from "vuex";
import { sortInKey, justOneOfSame } from "@/utils";
import Tooltip from "@/components/app/Tooltip";

export default {
  components: {
    Tooltip,
  },
  props: {
    calculation: {
      type: Object,
    },
    solutions: {
      type: Array,
    },
    value: {
      required: true,
    },
  },
  data() {
    return {
      selectedSolution: null,
    };
  },

  computed: {
    ...mapState(["selectedLang"]),

    totalMainSpans() {
      const { hasCantilever, modelSpans } = this.calculation.input;
      return hasCantilever ? modelSpans.length - 2 : modelSpans.length;
    },

    solutionsByType() {
      return this.solutions.reduce((result, solution) => {
        const { type } = solution;

        if (!(type in result)) {
          result[type] = [];
        }

        result[type].push(solution);

        return result;
      }, {});

      // {
      // type1: [
      // 	{}
      // 	{}
      // ],
      // type2: [
      // 	...
      // ]
      // }
    },

    solutionsByTypeSortedbyWeight() {
      const solutionsByTypeSortedbyWeight = Object.fromEntries(
        Object.entries(this.solutionsByType).map(([type, solutions]) => {
          return [type, sortInKey(solutions, "totalWeightAlignment")];
        })
      );

      return solutionsByTypeSortedbyWeight;
      // {
      // type1: [
      // 	{} //ordenado por peso
      // 	{}
      // ],
      // type2: [
      // 	...
      // ]
      // }
    },

    solutionsByTypeSortedByWeightWithJustOneOfSameSteel() {
      const x = Object.fromEntries(
        Object.entries(this.solutionsByTypeSortedbyWeight).reduce(
          (result, [type, solutions]) => {
            const justOneOfSameSteel = justOneOfSame(solutions, "steel");

            if (justOneOfSameSteel.length) {
              return [...result, [type, justOneOfSameSteel]];
            }

            return result;
          },
          []
        )
      );

      return x;
    },
  },

  methods: {
    handleSolutionRowClick(e, solution) {
      this.selectedSolution = solution;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.selectedSolution = val;
      },
    },

    selectedSolution() {
      this.$emit("input", this.selectedSolution);
    },
  },
};
</script>

<style lang="scss" scoped>
$base-unit: 8px;
$thead-side-padding: $base-unit;
$solution-cell-vertical-padding: $base-unit * 3;
$solution-row-side-padding: $base-unit * 2;

thead {
  border-bottom: 1px solid #d0d0d0;
}

th {
  vertical-align: bottom;
  padding-bottom: 8px;
}

th:first-child {
  padding-left: $thead-side-padding;
}

th:last-child {
  padding-right: $thead-side-padding;
}

th > * {
  line-height: 1;
}

td {
  vertical-align: middle;
}

th,
.solution_cell {
  padding-left: 8px;
}

.solution_row {
  cursor: pointer;
}

.solution_cell {
  padding-top: $solution-cell-vertical-padding;
  padding-bottom: $solution-cell-vertical-padding;
  background: #fff;
}

.solution_cell:first-child {
  padding-left: $solution-row-side-padding;
}

.solution_cell:last-child {
  padding-right: $solution-row-side-padding;
  text-align: right;
}

.solution_row.is-selected .solution_cell {
  background: $brand-l1;
}

.spacer_cell {
  padding-bottom: 8px;
}

.solution_val {
  color: #000;
  font-size: $font-size-l;
}

.no_solutions_cell {
  padding: 1em 8px;
}

.type_title {
  padding-top: 2em;
  padding-bottom: 0.5em;
}

.type_img {
  min-width: 19em;
  background-color: #e6e6e6;
}
</style>
